import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdAppGroupPermissionSetsDeletePermissionSetIdCacheKeys: AllRouteEndpoints[] = [
  "/companies/:company_id/app_group_permission_sets/all_permission_sets",
];
